import {
  RequirementDefinitionAutoLiabilityFormValues,
  RequirementDefinitionGeneralLiabilityFormValues,
  RequirementDefinitionProfessionalLiabilityFormValues,
  RequirementDefinitionWorkInjuryFormValues
} from "../../../../types";
import { FlowCreateNewVersionSettingsData } from "../../types";
import { getAutoLiabilitySettings } from "./getAutoLiabilitySettings";
import { getGeneralLiabilitySettings } from "./getGeneralLiabilitySettings";
import { getProfessionalLiabilitySettings } from "./getProfessionalLiabilitySettings";
import { getWorkInjurySettings } from "./getWorkInjurySettings";

export const getInsuranceCoverageSettings = (
  settings: FlowCreateNewVersionSettingsData
): string[] => {
  const s = settings as
    | Partial<RequirementDefinitionAutoLiabilityFormValues>
    | Partial<RequirementDefinitionGeneralLiabilityFormValues>
    | Partial<RequirementDefinitionProfessionalLiabilityFormValues>
    | Partial<RequirementDefinitionWorkInjuryFormValues>;

  if (
    "perIncidentLimitMinimum" in s &&
    s.perIncidentLimitMinimum !== undefined
  ) {
    return getGeneralLiabilitySettings(
      s as Partial<RequirementDefinitionGeneralLiabilityFormValues>
    );
  }
  if ("perClaimLimitMinimum" in s && s.perClaimLimitMinimum !== undefined) {
    return getProfessionalLiabilitySettings(
      s as Partial<RequirementDefinitionProfessionalLiabilityFormValues>
    );
  }
  if ("workersCompLimitMinimum" in s || "occAccidentMedicalMinimum" in s) {
    return getWorkInjurySettings(
      s as Partial<RequirementDefinitionWorkInjuryFormValues>
    );
  }
  if ("coverageLimitMinimum" in s && s.coverageLimitMinimum !== undefined) {
    return getAutoLiabilitySettings(
      s as Partial<RequirementDefinitionAutoLiabilityFormValues>
    );
  }

  return ["No coverages configured"];
};
